import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ArrowLeft, Edit2, Save, ListOrdered } from 'lucide-react';
import { toast } from 'sonner';

export default function CompetitionDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [competition, setCompetition] = useState(null);
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  
  useEffect(() => {
    axios.get(`${API}/competitions/${id}`, { withCredentials: true })
      .then(res => {
        setCompetition(res.data);
        setName(res.data.name);
        setDate(res.data.date);
        setDescription(res.data.description || '');
      })
      .catch(err => console.error(err));
  }, [id]);
  
  const handleSave = async () => {
    try {
      await axios.patch(`${API}/competitions/${id}`, {
        name,
        date,
        description
      }, { withCredentials: true });
      toast.success('Competition updated!');
      setEditing(false);
      setCompetition({ ...competition, name, date, description });
    } catch (error) {
      toast.error('Failed to update competition');
    }
  };
  
  if (!competition) return <div>Loading...</div>;
  
  return (
    <div className="space-y-6 fade-in">
      <Button variant="ghost" onClick={() => navigate('/competitions')} data-testid="back-button">
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Competitions
      </Button>
      
      <Card className="p-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Manrope, sans-serif', color: '#2D4A3E' }}>
            {editing ? 'Edit Competition' : competition.name}
          </h1>
          {!editing ? (
            <Button onClick={() => setEditing(true)} data-testid="edit-button">
              <Edit2 className="mr-2 h-4 w-4" />
              Edit
            </Button>
          ) : (
            <Button onClick={handleSave} data-testid="save-button">
              <Save className="mr-2 h-4 w-4" />
              Save
            </Button>
          )}
        </div>
        
        {editing ? (
          <div className="space-y-4">
            <div>
              <Label>Name</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="edit-name-input" />
            </div>
            <div>
              <Label>Date</Label>
              <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="edit-date-input" />
            </div>
            <div>
              <Label>Description</Label>
              <Input value={description} onChange={(e) => setDescription(e.target.value)} data-testid="edit-description-input" />
            </div>
          </div>
        ) : (
          <div className="space-y-3">
            <p><strong>Date:</strong> {competition.date}</p>
            {competition.description && <p><strong>Description:</strong> {competition.description}</p>}
            <p className="text-sm text-muted-foreground">Created: {new Date(competition.created_at).toLocaleDateString()}</p>
            
            <div className="pt-4 border-t mt-6">
              <Button 
                onClick={() => navigate(`/competitions/${id}/order-of-skate`)} 
                className="btn-primary"
                data-testid="order-of-skate-btn"
              >
                <ListOrdered className="mr-2 h-4 w-4" />
                Order of Skate
              </Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
